import axios from "../utils/axios"; 

/**
 * Публікація сайту
 * @returns 
 */
export const publish = async () =>{ 
    try {   
        const response = await axios.post('/site/publish');
        return response.data.stat||false;
    } catch(e){
        console.log(e);
        return false;
    }
} 